class ScrollToTop {
  constructor() {
    this.button = null;
    this.init();
  }

  init() {
    // Find the scroll to top button
    this.button = document.querySelector(".scroll-to-top");
    if (!this.button) return;

    // Add click event listener
    this.button.addEventListener("click", () => {
      this.scrollToTop();
    });

    // Show/hide button based on scroll position
    window.addEventListener("scroll", () => {
      this.toggleVisibility();
    });

    // Initial check
    this.toggleVisibility();
  }

  scrollToTop() {
    window.scrollTo({
      top: 0,
      behavior: "smooth",
    });
  }

  toggleVisibility() {
    if (!this.button) return;

    const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

    if (scrollTop > 300) {
      this.button.classList.add("is-visible");
    } else {
      this.button.classList.remove("is-visible");
    }
  }
}

// Function to ensure page starts at top on load/refresh
function ensurePageStartsAtTop() {
  // Scroll to top immediately when page loads
  window.scrollTo(0, 0);

  // Also ensure it stays at top during page load
  document.addEventListener("DOMContentLoaded", () => {
    window.scrollTo(0, 0);
  });

  // Final check when everything is loaded
  window.addEventListener("load", () => {
    window.scrollTo(0, 0);
  });
}

// Initialize immediately to prevent any scroll position restoration
ensurePageStartsAtTop();

// Initialize when DOM is ready
document.addEventListener("DOMContentLoaded", () => {
  new ScrollToTop();
});

// Also initialize for dynamic content
document.addEventListener("shopify:section:load", () => {
  new ScrollToTop();
});
